<template>
  <div
    class="carousel-container"
    :style="containerStyle"
    @mouseenter="pauseAnimation"
    @mouseleave="resumeAnimation"
  >
    <div
      class="carousel-content"
      :class="direction"
      :style="contentStyle"
      ref="content"
    >
      <div
        v-for="(item, index) in doubledData"
        :key="item[dataKey] || index"
        class="carousel-item"
        :style="itemStyle"
      >
        <slot :item="item" :index="index % dataSources.length"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    dataSources: {
      type: Array,
      required: true
    },
    size: {
      type: Number,
      default: 50
    },
    height: {
      type: Number,
      default: 300
    },
    width: {
      type: Number,
      default: 300 // 横向时使用
    },
    dataKey: {
      type: String,
      default: "id"
    },
    duration: {
      type: Number,
      default: 20
    },
    direction: {
      type: String,
      default: "vertical", // vertical | horizontal
      validator: val => ["vertical", "horizontal"].includes(val)
    }
  },
  data() {
    return {
      isPaused: false
    };
  },
  computed: {
    doubledData() {
      return [...this.dataSources, ...this.dataSources];
    },
    containerStyle() {
      return {
        overflow: "hidden",
        position: "relative",
        height:
          this.direction === "vertical" ? this.height + "px" : this.size + "px",
        width: this.direction === "horizontal" ? this.width + "px" : "100%"
      };
    },
    contentStyle() {
      return {
        animationPlayState: this.isPaused ? "paused" : "running",
        animationDuration: this.duration + "s"
      };
    },
    itemStyle() {
      return this.direction === "vertical"
        ? {
            height: this.size + "px",
            lineHeight: this.size + "px"
          }
        : {
            width: this.size + "px",
            height: "100%"
          };
    }
  },
  methods: {
    pauseAnimation() {
      this.isPaused = true;
    },
    resumeAnimation() {
      this.isPaused = false;
    }
  }
};
</script>

<style scoped>
.carousel-content {
  display: flex;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  gap: 20px;
}

.carousel-content.vertical {
  flex-direction: column;
  animation-name: scrollUp;
}

.carousel-content.horizontal {
  flex-direction: row;
  animation-name: scrollRight;
}

.carousel-item {
  box-sizing: border-box;
  padding: 0 10px;
  user-select: none;
  flex-shrink: 0;
}

/* 竖向：从下往上 */
@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}

/* 横向：从左往右 */
@keyframes scrollRight {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VirtualList/index.vue